import axios from 'axios';
import config from '../config';
import { DeviceSecrets } from '../interfaces';

export const getOnboardDeviceSecrets = (deviceId: string): Promise<DeviceSecrets> => {
    return axios.get(`${config.API_URL}/onboard-devices/${deviceId}/secrets`).then((response: any) => {
        return response.data.data.secrets;
    });
};
